import { useMemo, useRef } from 'react';
import noop from 'lodash/noop';
import { useToggleSideNav } from '@atlaskit/navigation-system/layout/side-nav';
import type { UIControllerSubscriberProps, UIControllerInterface } from './types.tsx';

const defaultState: UIControllerInterface = {
	state: {
		isCollapsed: false,
		isResizing: false,
		isResizeDisabled: false,
		productNavWidth: 0,
	},
	collapse: noop,
	expand: noop,
	toggleCollapse: noop,
};

export const UIControllerSubscriber = ({ children }: UIControllerSubscriberProps) => {
	const toggleSideNav = useToggleSideNav();

	const stateRef = useRef<UIControllerInterface>({
		...defaultState,
		toggleCollapse: toggleSideNav,
	});

	const navigationUIController = useMemo<UIControllerInterface>(
		() => ({
			...defaultState,
			toggleCollapse: toggleSideNav,
		}),
		[toggleSideNav],
	);

	stateRef.current = Object.assign(stateRef.current, navigationUIController);

	return children(stateRef.current);
};
